<template>
  <div class="full-page-width view-shipment">
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="routeIt"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name" v-if="get_single_pickup !== null">{{ `Pickup at ${get_single_pickup.full_address}` }}</p>
      </div>
      <Dropdown
        class="float-right drop-right"
        :buttonText="$t('Actions')"
        :dropdownOptions="dropdownOptions"
        @optionSelected="optionSelected" />
    </div>
    <!-- HEADER -->
    <div class="row card info-wrap m-b-40" v-if="get_single_pickup !== null">
      <div class="flex">
        <div class="info-box fix-width-position">
          <p class="small-text">{{ formatDate(get_single_pickup.pickup_date, 'shipment') }}</p>
          <p class="big-text">
            <span class="cut-text medium">{{ get_single_pickup.city }}</span>
            <span class="align-middle">{{ `, ${ countryAlpha2(get_single_pickup.country_id)}` }}</span>
          </p>
          <p class="small-text tooltip-holder">
            <span class="cut-text small">{{ get_single_pickup.company_name ||  get_single_pickup.name}}</span>
            <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRef' }"
                  name="info"
                  size="15" />
          <div class="info-tooltip-window" ref="tooltipRef">
            <p v-if="get_single_pickup.company_name">{{ get_single_pickup.company_name }}</p>
            <p v-if="get_single_pickup.name">{{ get_single_pickup.name }}</p>
            <p v-if="get_single_pickup.address_1">{{ get_single_pickup.address_1 }}</p>
            <p v-if="get_single_pickup.address_2">{{ get_single_pickup.address_2 }}</p>
            <p v-if="get_single_pickup.post_code || get_single_pickup.city">{{ `${get_single_pickup.post_code} ${get_single_pickup.city}` }}</p>
            <p v-if="get_single_pickup.state">{{ get_single_pickup.state }}</p>
            <p v-if="get_single_pickup.country_id">{{ countryName(get_single_pickup.country_id) }}</p>
            <p v-if="get_single_pickup.phone">{{ `+${get_single_pickup.phone}` }}</p>
            <p v-if="get_single_pickup.email">{{ get_single_pickup.email }}</p>
          </div>
          </span>
          </p>
        </div>
        <div class="middle-box status-box">
          <div
            class="shipment-status-bar step1">
            <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
              <line x1="0" y1="0" x2="100%" y2="0" />
            </svg>
            <div class="icon-point">
              <p class="status-text">{{ $t('waiting_for_booking') }}</p>
              <Icon
                  style="text-align: center;"
                  :name="'pin'"
                  size="15"/>
            </div>
            <div class="point-one"></div>
            <div class="point-two"></div>
          </div>
          <p class="update-info">
            <!--              {{ `${$t('last_update')}` }} <span style="text-transform: lowercase">{{ `${formatDate(get_single_pickup.shipment_status_date, 'shipment_last_update')}` }} </span> |-->
            <!--              {{ $t(get_single_pickup.shipment_status_message) }}-->
          </p>
        </div>
        <div class="info-box fix-width-position">
          <p class="small-text">{{ `${get_single_pickup.packages_count} colli` }}</p>
          <p class="big-text">
            <span class="medium">{{ parseFloat(get_single_pickup.weight ? get_single_pickup.weight : 0) | weight}}</span>
          </p>
          <p class="small-text">
            <span class="small"> {{ `${getVolumeText(get_single_pickup.vol_dm3)}` }}</span><span style="vertical-align: super;
                        font-size: 10px;
                        line-height: 0px;">3</span>
          </p>
        </div>
      </div>
    </div>
    <!-- BODY -->
    <div class="row">
      <h2 class="m-b-20 section-title" v-if="get_pickup_shipments_list !== null">
        Shipments
        <span class="grayed">{{ `(${get_pickup_shipments_count})` }}</span>
      </h2>
      <DataTable
        :dropdown=false
        :tableHeader=false
        :tableHead=false
        tableAPI="NOT_PLANNED_PICKUP_SHIPMENTS"
        tableActions="NOT_PLANNED_PICKUP_SHIPMENTS"
        :apiID="$route.params.id"
        :actionsOptions="actionsOptions"
        :totalCount="totalCount"
        :checkbox=true
        :type=type
        :count="get_pickup_shipments_count"
        :list="get_pickup_shipments_list"
        :referenceData="referenceData"
        :filterOptions="filterOptions"
        :rowActionParameter="rowActionParameter"
        :showRowValueWithPrefix=true
        @actionOptionTriggered="actionsOptionTriggered"
        @rowAction="rowAction" />
    </div>
    <Popup
      v-if="showChangeAddressPopup"
      min-height="400px"
      :popupLarge=true
      @cancel="toggleChangeAddressPopup"
      @confirm="submitChangeAddress">
      <template v-slot:header>
        <h2>{{ $t('change_address') }}</h2>
      </template>
      <div>
        <InputSelect
          :class="isForeignPickupLocation ? 'm-b-input' : ''"
          :label="$t('pickup_location')"
          v-model="pickupLocationId"
          @change="checkForForeign"
          :countryFlag="true"
          :options="pickupLocationOptions"
        />
        <AddressPicker
          class="m-b-input"
          v-if="isForeignPickupLocation"
          :label="$t('address_1')"
          placeholder="Search address"
          @addressSelected="changeAddress('pickup', $event)"
          v-model="pickupAddress"
        />
      </div>
      <div class="row" v-if="isForeignPickupLocation">
        <div class="col-xs-12 m-b-20">
          <InputText
            :label="$t('company_name')"
            v-model="pickupData.company"
            :rules="{required: true}"/>
        </div>
        <div class="col-xs-12 m-b-20">
          <InputText
            :label="$t('name')"
            v-model="pickupData.attention"
            :rules="{required: false}"/>
        </div>
        <div class="col-xs-6">
          <PhoneSelect v-model="pickupData.phone" :rules="{required: false}"/>
        </div>
        <div class="col-xs-6 m-b-20">
          <InputText
            label="Email"
            v-model="pickupData.email"
            :rules="{required: false, email: false}"/>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="showMoveShipmentToBookedPickupPopup"
      min-height="400px"
      :popupLarge=true
      :showConfirmButton="!!Object.keys(selectedBookedPickup).length"
      @cancel="toggleMoveShipmentToBookedPickupPopup"
      @confirm="submitMoveShipmentToBookedPickup">
      <template v-slot:header>
        <h2>{{ $t('move_to_booked') }}</h2>
      </template>
      <div class="row">
        <div class="col-xs-12 m-b-20">
          <div class="row m-b-input">
            <div class="col-xs-12">
              <Calendar
                :label="$t('pickup_date')"
                v-model="moveShipmentToBookedPickupData.pickupDate"
                :date="getPickupDate"
                :rules="{required: true}" />
            </div>
          </div>
        </div>
      </div>
      <p>{{ $t('existing_pickup')}}</p>
      <div class="m-t-20">
        <div>
          <div>
            <div
              v-for="(existingPickup, index) in availableBookedPickups" :key="`mtb-row-${index}`" >
              <div class="toggle-card-box card no-padding">
                <div
                  @click="selectBookedPickupToMoveShipmentsIn(existingPickup)"
                  class="toggle-card-header"
                  :class="{ 'pickup-selected': !!Object.keys(selectedBookedPickup).length }">
                  <div class="info-box">
                    <div class="title-holder">
                      <LogosSVG :name="existingPickup.shipping_agent_name" size="62" class="m-r-20" />
                      <div>
                        <span class="sub-title m-b-5">{{ existingPickup.shipping_product_name}}</span>
                        <span class="title b-block m-b-5">{{ `${existingPickup.full_address}` }}</span>
                        <span class="sub-title">{{ `${existingPickup.packages_count} colli ` }} ({{ parseFloat(existingPickup.weight ? existingPickup.weight : 0) | weight }})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="showPickupPopup"
      min-height="400px"
      :popupLarge=true
      :showConfirmButton="false"
      @cancel="togglePickupPopup"
      @confirm="bookPickup">
      <template v-slot:header>
        <h2>{{ $t('book_pickup') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12 m-b-20">
            <div class="row m-b-input">
              <div class="col-xs-6">
                <Calendar
                  :label="$t('pickup_date')"
                  v-model="pickupData.pickupDate"
                  :date="getPickupDate"
                  :rules="{required: true}" />
              </div>
              <div class="col-xs-6">
                <InputText
                  v-cloak
                  v-model="pickupData.reference"
                  :label="$t('reference')"
                  :rules="{required: false}"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="d-inline-block m-r-20">
            <Toggle
                class="m-r-10"
                id="show_add_manual_shipment"
                v-model="showManualShipmentBlock"
                @change="resetShipments"
            />
            {{ $t('add_manual_shipments_row') }}
          </div>
          <ManualShipmentsBlock class="p-t-20"
            v-if="showManualShipmentBlock"
            v-model="pickupShipments "/>
        </div>
      </div>
      <!-- Products -->
      <message v-if="!productCardDataValid" name="warning" :data="data={data: this.productCardErrorMessage, type:'validation'}"></message>
      <div v-if="!reloadingProducts && productCardDataValid">
        <h2 class="m-b-20 p-t-30 section-title">{{ $t('pickup_options_on_this_address') }}</h2>
        <ProductCard
          v-for="(product, index) in productsList"
          :key="`product-${product.shipping_product_id}-${index}`"
          :product="product"
          :pickupDate="pickupData.pickupDate"
          :pageType="'view'"
          :isOpened="(selectedProduct != null) && (selectedProduct.shipping_product_id == product.shipping_product_id)"
          @bookPickup="bookPickup"
          :disableButton="disableButton"
          :loadingButton="loadingButton"
          @selected="selectProduct" />
      </div>
    </Popup>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import LogosSVG from "@/assets/images/logosSVG";
import DataTable from '@/components/table/index.vue';
import Btn from '@/components/elements/buttons';
import Dropdown from '@/components/global/dropdown';
import date from '@/mixins/date';
import Popup from '@/components/global/popup';
import InputText from '@/components/elements/inputs/text.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';

import Calendar from '@/components/elements/inputs/calendar.vue';
import ManualShipmentsBlock from '@/components/pickup/manualShipmentsBlock';
import ProductCard from '@/components/pickup/productCard';
import PickupPopupMixin from '@/mixins/bookPickupPopup';
import mixin from '@/mixins/mixins.js';
import countryList from "@/data/country";
import moment from "moment";

export default {
  name: 'NotPlannedPickupView',
  components: {
    LogosSVG,
    DataTable,
    Btn,
    Dropdown,
    Popup,
    InputText,
    InputSelect,
    Toggle,
    AddressPicker,
    PhoneSelect,
    Calendar,
    ManualShipmentsBlock,
    ProductCard
  },
  mixins: [date, PickupPopupMixin, mixin],
  data() {
    return {
      isFromViewPage: true,
      productCardDataValid: false,
      productCardErrorMessage: '',
      productsList: null,
      selectedProduct: null,
      reloadingProducts: false,
      pickupLocationOptions: [],
      cachedPickupLocation: {},
      pickupLocationId: null,
      isForeignPickupLocation: false,
      isPickupPopupSubmitDisabled: false,
      isTableAllSelected: false,
      showPickupPopup: false,
      showChangeAddressPopup: false,
      showImportButton: false,
      updateIterator: 1,
      totalCount: 10,
      disableButton: false,
      loadingButton: false,
      checkedShipmentIds: [],
      showMoveShipmentToBookedPickupPopup: false,
      availableBookedPickups: [],
      selectedBookedPickup: {},
      moveShipmentToBookedPickupData: {
        pickupDate: ''
      },
      referenceData: [
        {
          shipping_product_name: '',
          shipping_agent_name: '',
        },
        {
          packages_count_and_goods_type: '',
          trace_no: '',
        },
        {
          sender_reference: `${this.$t('Sender ref.:')}`,
          receiver_reference: `${this.$t('Reciever ref.:')}`,
        },
      ],
      rowActionParameter: {
        param: 'id',
        text: 'View shipment',
      },
      type: {
        type: false,
        data: 'status',
      },
      dropdownOptions: [
        {
          text: this.$t('book_pickup'),
          subText: this.$t('book_pickup_subtext'),
          icon: 'pointer',
        },
        {
          text: this.$t('change_address'),
          subText: this.$t('change_address_subtext'),
          icon: 'pen',
        },
      ],
      actionsOptions: [
        {
          text: this.$t('remove'),
          subText: this.$t('remove_from_pickup_subtext'),
          icon: 'deleteForever',
        },
        {
          text: this.$t('move_to_existing'),
          subText: this.$t('move_to_existing_subtext'),
          icon: 'swapVertical',
        },
      ],
      waybillsPdfPath: '',
      exportDataPath: '',
    };
  },
  computed: {
    tableType() {
      return 'BookedPickups';
    },
    ...mapGetters([
      'get_pickup_shipments_list',
      'get_pickup_shipments_count',
      'get_single_pickup',
      'get_active_subaccount',
      'get_pickup_locations',
      'get_error_message',
      'get_booked_pickup_list',
      'get_booked_pickup_count',
      'get_filters_menu',
      'get_active_filter',
      'get_pickup_shipment_by_id'
    ]),
    getPickupDate() {
      const todayDate = new Date();
      const pickupDate = new Date(this.get_single_pickup.pickup_date)
      return pickupDate < todayDate ? todayDate : pickupDate;
    },
    filterOptions() {
      return {
        filtersMenu: this.get_filters_menu,
        activeFilter: this.get_active_filter,
        tableName: 'bookedPickups',
        tableApi: 'pickup/get-booked-list',
        filterFields: {
          status: {
            label: 'Status',
            type: 'select',
            value: {
              value: '',
              additional: '',
            },
            options: [
              {text: 'Canceled', value: '5'},
              {text: 'Printed', value: '3'},
              {text: 'On hold', value: '23'},
              {text: 'Sent', value: '4'},
              {text: 'Recived by agent', value: '12'},
              {text: 'On the way', value: '13'},
              {text: 'Issue', value: '16'},
              {text: 'In pickup point', value: '15'},
              {text: 'Delivered', value: '14'},
            ],
          },
          ship_date: {
            label: 'Ship date',
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          created_at: {
            label: 'Created date',
            type: 'date',
            value: {
              value: null,
              additional: '',
            },
          },
          subaccount_id: {
            label: 'Account',
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_agent_name: {
            label: 'Carrier',
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          shipping_product_name: {
            label: 'Product name',
            type: 'input',
            value: {
              value: '',
              additional: '',
            },
          },
          weight: {
            label: 'Weight',
            type: 'options',
            value: {
              value: '',
              additional: '',
            },
          },
        }
      }
    },
  },
  methods: {
    actionsOptionTriggered(opt) {
      this.checkedShipmentIds = opt.list;
      if(opt.dropOption === 'dropOption1') {
        // Remove shipment from booked pickup, this can only happen when pickup is in booked (printed) status
        this.$store.dispatch('REMOVE_SHIPMENTS_FROM_NOT_PLANNED_PICKUP', {id: this.$route.params.id, shipmentIds: this.checkedShipmentIds}).then((res) => {
          this.$store.dispatch('GET_NOT_PLANNED_PICKUP_SHIPMENTS', {id: this.$route.params.id});
          if (res.data.data.shipments_count === 0) {
            this.$router.push('/pickups/not-planned');
          }
        });
      }
      if(opt.dropOption === 'dropOption2') {
        this.toggleMoveShipmentToBookedPickupPopup();
      }
    },
    routeIt() {
      this.$router.go(-1);
    },
    countryAlpha2(id) {
      return this.getCountry(id, 'alpha2');
    },
    countryName(id){
      return this.getCountry(id, 'name');
    },
    getPopupAddress() {
      return {
        company_name: this.pickupData.company,
        name: this.pickupData.attention,
        post_code: this.pickupAddress.post_code,
        country_code: this.getCountry(this.pickupAddress.country_id, 'alpha2'),
        country_id: this.pickupAddress.country_id,
        address_1: this.pickupAddress.address_1,
        address_2: this.pickupAddress.address_2,
        city: this.pickupAddress.city,
        phone: this.pickupData.phone.number,
        email: this.pickupData.email
      }
    },
    getRequestFormattedAddress() {
      return {
        company_name: this.get_single_pickup.company_name,
        name: this.get_single_pickup.name,
        post_code: this.get_single_pickup.post_code,
        country_code: this.getCountry(this.get_single_pickup.country_id, 'alpha2'),
        country_id: this.get_single_pickup.country_id,
        address_1: this.get_single_pickup.address_1,
        address_2: this.get_single_pickup.address_2,
        city: this.get_single_pickup.city,
        phone: this.get_single_pickup.phone,
        email: this.get_single_pickup.email
      };
    },
    clearAddressRelatedData() {
      this.isForeignPickupLocation = false;
      this.pickupLocationId = null;
      this.cachedPickupLocation = this.pickupLocationId;
      this.clearAddressData('pickup');
    },
    optionSelected(opt) {
      if(opt === 'dropOption1') {
        this.openCreatePickupPopup();
      }else if(opt === 'dropOption2') {
        this.openChangeAddressPopup();
      }
    },
    toggleChangeAddressPopup() {
      this.showChangeAddressPopup = !this.showChangeAddressPopup;
      this.clearAddressRelatedData();
    },
    togglePickupPopup() {
      this.showPickupPopup = !this.showPickupPopup;
      this.clearBookPickupData();
    },
    // Table actions
    tableSelectionsUpdated(val) {
      this.isTableAllSelected = val.selectTotalRows;
    },
    rowAction(val) {
      const shipment = this.get_pickup_shipment_by_id(val);
      //If shipment is not vendor type, go to shipment view
      if (shipment.shipment_type !== 6) {
        this.$router.push(`/view-shipment/${val}`);
      }
    },
    openChangeAddressPopup() {
      this.$store.dispatch('GET_PICKUP_LOCATIONS').then((res) => {
        this.pickupLocationOptions = [
          {value: null, text: 'Other address', country: ''},
          ...res.map((opt) => {
            return {
              value: opt.id,
              country: opt.country_id ? this.getCountry(opt.country_id, 'alpha2') : '',
              text: `
                ${opt.company_name ? opt.company_name + ', ' : ''}
                ${opt.name ? opt.name + ', ' : ''}
                ${opt.address_1 ? opt.address_1 + ', ' : ''}
                ${opt.post_code ? opt.post_code + ', ' : ''}
                ${opt.city ? opt.city + ', ' : ''}
                ${opt.state ? opt.state + ', ' : ''}
                ${opt.country_id ? this.getCountry(opt.country_id, 'name') : ''}
              `
            };
          }),
        ];

        this.showChangeAddressPopup = true;
        this.isForeignPickupLocation = true;
        const data = this.get_single_pickup;
        this.pickupData = {
          ...this.pickupData,
          company: data.company_name || '',
          attention: data.name,
          email: data.email,
          phone: {'number': data.phone, 'country': countryList.filter((opt) => parseInt(opt.id) === parseInt(data.country_id))[0].alpha2},
        };

        this.pickupAddress = {
          address_1: this.get_single_pickup.address_1,
          address_2: this.get_single_pickup.address_2,
          post_code: this.get_single_pickup.post_code,
          city: this.get_single_pickup.city,
          country_id: this.get_single_pickup.country_id,
          state: this.get_single_pickup.state,
        };
      });
    },
    changeAddressDataIsValid() {
      let result = true;
      this.productCardErrorMessage = `${this.$t('validation_message_services')}: </br></br>`
      if(!this.isAddressInfoValid()) {
        result = false;
      }

      this.productCardErrorMessage = this.productCardErrorMessage.replace(/,\s*$/, '');
      this.productCardDataValid = result;
      return result;
    },
    submitChangeAddress() {
      const payload = {
        data: {
          ...this.getPopupAddress(),
        },
        id: this.$route.params.id
      }

      this.$store.dispatch('UPDATE_PICKUP_ADDRESS', payload).then(() => {
        this.toggleChangeAddressPopup();
        this.$store.dispatch('GET_NOT_PLANNED_SINGLE_PICKUP', this.$route.params.id);
      });
    },
    bookPickup(childData) {
      const payload = {
        allowed_awbs: childData.product.allowed_shipment_awbs,
        subaccount_id: this.get_active_subaccount.id,
        not_planned_pickup_id: this.$route.params.id,
        booked_pickup_id: (childData.should_move_shipments_to_existing_pickup && childData.product.booked_pickup_id) ? childData.product.booked_pickup_id : null,
        pickup_date: this.pickupData.pickupDate,
        pickup_time_from: childData.pickup_time_from,
        pickup_time_until: childData.pickup_time_until,
        pickup_driver_note: childData.pickup_driver_note,
        shipping_product_id: childData.product.shipping_product_id,
        address: this.getRequestFormattedAddress(),
        shipments: this.getRequestFormattedShipments()
      }
      this.disableButton = true;
      this.loadingButton = true;
      this.$store.dispatch('BOOK_PICKUP', payload).then((resp) => {
        this.togglePickupPopup();
        this.$router.push(`/pickups/booked/${resp.id}`);
      }).finally(() => {
        this.disableButton = false;
        this.loadingButton = false;
      });
    },
    clearBookPickupData() {
      this.pickupShipments = [];
      this.pickupData = {
        pickupDate: '',
        reference: '',
      };
    },
    //MOVE SHIPMENT INTO BOOKED PICKUP
    toggleMoveShipmentToBookedPickupPopup() {
      this.showMoveShipmentToBookedPickupPopup = !this.showMoveShipmentToBookedPickupPopup;
      this.clearMoveShipmentToBookedPickupData();
    },
    selectBookedPickupToMoveShipmentsIn(val) {
      this.selectedBookedPickup = val;
    },
    getAvailableBookedPickups (pickupDate) {
      const peTransformed = moment(pickupDate).format('DD.MM.YYYY');
      this.$store.dispatch('GET_AVAILABLE_BOOKED_PICKUPS', {id: this.$route.params.id, shipmentIds: this.checkedShipmentIds, pickupDate: peTransformed}).then((res) => {
        this.availableBookedPickups = res;
      });
    },
    submitMoveShipmentToBookedPickup() {
      if (!Object.keys(this.selectedBookedPickup).length) {
        console.log('Pickup not selected');
        return;
      }

      const payload = {
        data: {
          ...this.moveShipmentToBookedPickupData
        },
        shipmentIds: this.checkedShipmentIds,
        moveFromPickupId: this.$route.params.id,
        moveToPickupId: this.selectedBookedPickup.id
      };
      this.$store.dispatch('MOVE_SHIPMENTS_TO_BOOKED_PICKUP', payload).then((res) => {
        this.toggleMoveShipmentToBookedPickupPopup();
        this.$store.dispatch('GET_NOT_PLANNED_PICKUP_SHIPMENTS', {id: this.$route.params.id});
        if (res.data.data.shipments_count === 0) {
          this.$router.push('/pickups/not-planned');
        }
      });
    },
    clearMoveShipmentToBookedPickupData() {
      this.moveShipmentToBookedPickupData = {
        pickupDate: ''
      }
      this.availableBookedPickups = [];
      this.selectedBookedPickup = {};
    }
  },
  mounted() {
    this.$store.dispatch('GET_NOT_PLANNED_SINGLE_PICKUP', this.$route.params.id);
  },
  destroyed() {
    this.$store.dispatch('CLEAR_SINGLE_PICKUP');
  },
  watch: {
    observableObject: {
      handler(newVal, oldVal){
        if(this.popupDataIsValid(false)){
          this.makeCall(true);
        }
      },
      deep: true
    },
    'moveShipmentToBookedPickupData.pickupDate': {
      handler(newVal, oldVal){
        if(newVal && (newVal !== oldVal)){
          this.getAvailableBookedPickups(newVal);
        }
      },
      deep: true
    },
    getPopupAddress: {
      handler(newVal, oldVal){
        this.changeAddressDataIsValid()
      },
    }
  }
}
</script>
